import type { MouseEvent } from 'react';

/**
 * Спред-пропсы для <div className="modal-backdrop">, чтобы клик по нему закрывал модалку —
 * но не тогда, когда пользователь просто выделяет текст мышью внутри модалки (строка поиска,
 * имя пользователя и т.п.) и отпускает кнопку мыши уже за её пределами. В этом случае браузер
 * всё равно шлёт "click" на backdrop (ближайший общий предок таргетов mousedown/mouseup), хотя
 * закрыть окно никто не пытался (отчёт пользователя "выделение строки с поиском участника
 * группы — окно закрывается"). Считаем клик закрывающим только если И mousedown, И сам клик
 * пришлись на сам backdrop, а не на дочерний элемент — двух проверок вместо одной "onClick на
 * backdrop", т.к. e.target у click-события — это как раз таргет mouseup, а не mousedown.
 * Состояние храним в самом DOM-узле (dataset), не в замыкании — переживает ре-рендер между
 * mousedown и click одного и того же жеста.
 */
export function backdropClose<T extends HTMLElement = HTMLDivElement>(
  action: ((e: MouseEvent<T>) => void) | undefined,
) {
  return {
    onMouseDown: (e: MouseEvent<T>) => {
      e.currentTarget.dataset.downSelf = String(e.target === e.currentTarget);
    },
    onClick: (e: MouseEvent<T>) => {
      if (e.currentTarget.dataset.downSelf === 'true' && e.target === e.currentTarget) action?.(e);
    },
  };
}
